export const formatDateToMonthDayYear = (value: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: "numeric",
    month: "short",
    day: "numeric",
  };
  const date: Date = new Date(value);
  return date.toLocaleDateString("en-US", options);
};
